import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAuth } from "../../../../auth/useAuth";
import { useBookmarkContext } from "../../../../hooks/useBookmarkContext";
import { useCustomer } from "../../../../auth/useCustomer";

import "./BookmarkButton.scss";

function BookmarkButton({ onClick }) {
	const { currentUser } = useAuth();
	const [icons, setIcons] = React.useState(["fa-regular", "fa-bookmark"]);
	const { bookmarkItems } = useBookmarkContext();
	const CustomerContext = useCustomer();

	const hasCustomer = !!CustomerContext.customer;

	React.useEffect(() => {
		setIcons([bookmarkItems?.length ? "fa-solid" : "fa-regular", "fa-bookmark"]);
	}, [bookmarkItems]);

	if (!currentUser) {
		return (<></>);
	}

	return (
		<OverlayTrigger placement="bottom" overlay={
			<Tooltip className="_boss tooltip">Bookmarks</Tooltip>
		}>
			<div
				data-component="BookmarkButton"
				className={[hasCustomer && "customer-signed-in"].filter(c=>c).join(" ")}
			>
				<Button
					type="button"
					variant="link"
					className="bookmark-nav"
					onClick={e => onClick?.(e)}
				>
					<i className={icons?.join(" ") ?? ""}></i>
				</Button>
			</div>
		</OverlayTrigger>
	);
}

export default BookmarkButton;